import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  AuthRoutes,
  RouteParamsTypes,
  Modules,
  NonAuthRoutes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../enums';
import { MenuTextMapping } from '../utils/appConstant';
import { redirectBasedOnPermission } from '../utils/methods';
import { AuthContext } from '../contexts/AuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import PropertyList from '../modules/properties/list';
import PropertyAddEditView from '../modules/properties/addEditView';

const Properties: React.FC = () => {
  const { isSystemAdmin, permissions } = useContext(AuthContext);
  return (
    <Routes>
      <Route path={AuthRoutes.properties}>
        <Route
          path={AuthRoutes.properties + RouteParamsTypes.blank}
          element={
            <ProtectedRoute
              component={PropertyList}
              accessibleTo={[{ [PermissionModulesEnum.Properties]: [PermissionActionsEnum.View] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.properties + RouteParamsTypes.add}
          element={
            <ProtectedRoute
              component={PropertyAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Properties]: [PermissionActionsEnum.Add] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.properties + RouteParamsTypes.edit + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={PropertyAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Properties]: [PermissionActionsEnum.Update] }]}
            />
          }
        />
        <Route
          path={AuthRoutes.properties + RouteParamsTypes.view + RouteParamsTypes.id}
          element={
            <ProtectedRoute
              component={PropertyAddEditView}
              accessibleTo={[{ [PermissionModulesEnum.Properties]: [PermissionActionsEnum.View] }]}
            />
          }
        />
      </Route>

      <Route
        path={RouteParamsTypes.blank}
        element={
          <Navigate
            replace
            to={{
              pathname:
                redirectBasedOnPermission(isSystemAdmin, permissions, MenuTextMapping.properties) ||
                Modules.error + NonAuthRoutes.forbidden,
            }}
          />
        }
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default Properties;
